import { faroCoreApiClient } from "@api/faro-core-api-client";
import { createAsyncThunk } from "@reduxjs/toolkit";
/**
 * Fetches active members from the backend so they can be put into the store
 * @throws {HttpUtils.FetchError} if the Core API client request fails and not in dev mode
 */
export const fetchActiveMembers = createAsyncThunk("activeMembers/fetchActiveMembers", async ({
  companyId
}) => {
  return await faroCoreApiClient.company.getActiveMembers({
    companyId
  });
}, {
  condition: (_, {
    getState
  }) => {
    const state = getState();

    // Skip fetching if active members have already been fetched or fetching is in progress
    return state.activeMembers.fetching.status !== "succeeded";
  }
});

/**
 * Fetches the active members again once they are known, e.g. after a seat or a workspace role of
 * a member changed, which may make them an active user or not. The known members stay shown while
 * that happens, rather than all being shown as loading again.
 * @throws {HttpUtils.FetchError} if the Core API client request fails and not in dev mode
 */
export const refreshActiveMembers = createAsyncThunk("activeMembers/refreshActiveMembers", async ({
  companyId
}) => {
  return await faroCoreApiClient.company.getActiveMembers({
    companyId
  });
}, {
  condition: (_, {
    getState
  }) => {
    const {
      fetching,
      refreshStatus
    } = getState().activeMembers;
    // Only the active members that are known are refreshed, a pending fetch brings new ones
    // anyway. A refresh in progress is followed by another one once it is done, if the members
    // became outdated meanwhile, see useFetchActiveMembers
    return fetching.status === "succeeded" && refreshStatus !== "pending";
  }
});